export class LLMProvider {
  constructor(apiKey, config = {}) {
    if (new.target === LLMProvider) {
      throw new Error('LLMProvider è una classe astratta');
    }
    this.apiKey = apiKey;
    this.config = config;
  }

  // eslint-disable-next-line no-unused-vars
  async chat(messages) {
    throw new Error('Metodo chat() deve essere implementato');
  }

  // eslint-disable-next-line no-unused-vars
  async chatMultiTurn(messages, systemPrompt = '') {
    throw new Error('Metodo chatMultiTurn() deve essere implementato');
  }

  // eslint-disable-next-line no-unused-vars
  async chatWithImage(images, textPrompt, systemPrompt = '') {
    // images: Array<{ base64: string, mimeType: string }>
    throw new Error('Metodo chatWithImage() deve essere implementato');
  }

  /**
   * Streaming variant of chatMultiTurn. Calls onChunk with each text delta.
   * Default implementation falls back to non-streaming chatMultiTurn.
   * @param {Array} messages
   * @param {string} systemPrompt
   * @param {(chunk: string) => void} onChunk
   * @returns {Promise<string>} full response text
   */
  async chatMultiTurnStream(messages, systemPrompt = '', onChunk = () => {}) {
    const result = await this.chatMultiTurn(messages, systemPrompt);
    onChunk(result);
    return result;
  }

  async retryWithBackoff(fn, maxRetries = 3) {
    for (let i = 0; i < maxRetries; i++) {
      try {
        return await fn();
      } catch (error) {
        if (i === maxRetries - 1) throw error;
        const delay = Math.pow(2, i) * 1000;
        await new Promise(resolve => setTimeout(resolve, delay));
      }
    }
  }

  validateApiKey() {
    throw new Error('Metodo validateApiKey() deve essere implementato');
  }

  getModelName() {
    throw new Error('Metodo getModelName() deve essere implementato');
  }
}
